import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e7abd67")

_pushScopeId("data-v-4e7abd67")
const _hoisted_1 = { class: "home" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Banner = _resolveComponent("Banner")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Banner)
  ]))
})